<template>
  <div>
    <div class="search-container">
      <div class="search-box">
        <el-input v-model="searchTitle" @change="searchOrders" placeholder="请输入标题搜索" class="search-input" />
        <el-button type="primary" @click="searchOrders" class="search-btn">
          搜索
        </el-button>
      </div>
    </div>

    <div class="table-container">
      <el-table show-header highlight-current-row :data="orders" fit border style="width: 100%; min-width: 1400px;"
        :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column min-width="60" prop="id" label="ID" />
        <el-table-column min-width="300" prop="title" label="标题">
          <template #default="scope">
            <span class="title-text" @click="copyText(scope.row.title)">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" prop="business_id" label="business_id" />
        <el-table-column min-width="140" prop="business_code" label="business_code" />
        <!-- <el-table-column min-width="120" prop="business_value" label="business_value" /> -->
        <el-table-column min-width="120" prop="start_day" label="清洗开始时间" />
        <el-table-column min-width="120" prop="end_day" label="清洗结束时间" />
        <el-table-column min-width="100" label="清洗渠道">
          <template #default="scope">
            <el-tag :type="getChannelTagType(scope.row.clean_channel)" size="small">
              {{ getChannelText(scope.row.clean_channel) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="60" label="人群sql">
          <template #default="scope">
            <span class="sql-text" @click="showSqlDialog(scope.row.sql)">复制</span>
          </template>
        </el-table-column>
        <el-table-column min-width="60" label="结果sql">
          <template #default="scope">
            <span class="sql-text" @click="showSqlDialog(generateSqlFromRow(scope.row))">复制</span>
          </template>
        </el-table-column>
        <el-table-column min-width="160" prop="add_time" label="添加时间" />
        <el-table-column min-width="90" prop="add_user" label="创建人">
          <template v-slot="scope">
            <span v-if="!scope.row.add_user || scope.row.add_user === ''" style="color: #999;">
              历史记录
            </span>
            <span v-else style="color: #409EFF; font-weight: bold;">
              {{ scope.row.add_user }}
            </span>
          </template>
        </el-table-column>
        <el-table-column min-width="220" label="操作">
          <template #default="scope">
            <el-button @click="openEditDialog(scope.row)">查看清洗原始订单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- SQL查看弹窗 -->
    <el-dialog v-model="sqlDialogVisible" title="查看SQL" width="50%">
      <div style="word-break: break-all;">{{ selectedSql }}</div>
      <el-button @click="copySql">复制SQL</el-button>
    </el-dialog>

    <!-- SQL执行弹窗 -->
    <el-dialog center v-model="executeDialogVisible" title="查看清洗原始订单" fullscreen>
      <data-works-sql-execute v-if="executeDialogVisible" :sql="generatedSql" :auto-execute="false"
        :sql-templates="sqlTemplates" />
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { getTdzCleaningOrderListByTitle } from '@/utils/restApi';
import DataWorksSqlExecute from './DataWorksSqlExecute.vue';

const searchTitle = ref('');
const orders = ref([]);
const sqlDialogVisible = ref(false);
const selectedSql = ref('');
const currentRow = ref({});
const generatedSql = ref('');

const searchOrders = async () => {
  try {
    const result = await getTdzCleaningOrderListByTitle(searchTitle.value);
    if (result) {
      orders.value = result;
    }
  } catch (error) {
    console.error('获取订单列表失败:', error);
  }
};

// 组件加载时自动获取数据
onMounted(() => {
  searchOrders();
});

const showSqlDialog = (sql) => {
  selectedSql.value = sql;
  sqlDialogVisible.value = true;
};

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    ElMessage.success('复制成功');
  } catch (error) {
    console.error('复制失败:', error);
    ElMessage.error('复制失败');
  }
};

const copySql = () => {
  copyText(selectedSql.value);
};

const getChannelText = (channel) => {
  return channel === 'JD' ? 'JD' : 'TB';
};

const getChannelTagType = (channel) => {
  return channel === 'JD' ? 'success' : 'primary';
};

const executeDialogVisible = ref(false);
const sqlTemplates = ref([]);

const openEditDialog = (row) => {
  currentRow.value = { ...row };
  generatedSql.value = generateSqlFromRow(row);

  // SQL模板定义
  sqlTemplates.value = [{
    name: '原始数据',
    sql: generatedSql.value
  },
  {
    name: '下单/支付数',
    sql: `SELECT '下单' as title, CONCAT(MIN(time_scope),'_TO_',MAX(time_scope)) as time_scope, '全部' item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(total_fee) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
UNION ALL 
SELECT '支付' as title, CONCAT(MIN(time_scope),'_TO_',MAX(time_scope)) as time_scope, '全部' item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(payment) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and pay_time is NOT NULL;`
  },
  {
    name: '指定 商品下单/支付数',
    sql: `SELECT '下单' as title, CONCAT(MIN(time_scope),'_TO_',MAX(time_scope)) as time_scope, '全部' item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(total_fee) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and item_id in ('')
UNION ALL 
SELECT '支付' as title, CONCAT(MIN(time_scope),'_TO_',MAX(time_scope)) as time_scope, '全部' item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(payment) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and item_id in ('')
and pay_time is NOT NULL;`
  },
  {
    name: '按商品 下单/支付数',
    sql: `SELECT '下单' as title, CONCAT(MIN(time_scope),'_TO_',MAX(time_scope)) as time_scope, item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(total_fee) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
group by item_id
UNION ALL 
SELECT '支付' as title, CONCAT(MIN(time_scope),'_TO_',MAX(time_scope)) as time_scope, item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(payment) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and pay_time is NOT NULL
group by item_id;`
  },
  {
    name: '指定商品 按商品 下单/支付数',
    sql: `SELECT '下单' as title, CONCAT(MIN(time_scope),'_TO_',MAX(time_scope)) as time_scope, item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(total_fee) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and item_id in ('')
group by item_id
UNION ALL 
SELECT '支付' as title, CONCAT(MIN(time_scope),'_TO_',MAX(time_scope)) as time_scope, item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(payment) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and pay_time is NOT NULL
and item_id in ('')
group by item_id;`
  },
  {
    name: '按天下单/支付数',
    sql: `SELECT '下单' as title, time_scope as time_scope, '全部' item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(total_fee) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
GROUP BY time_scope
UNION ALL 
SELECT '支付' as title, time_scope as time_scope, '全部' item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(payment) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and pay_time is NOT NULL 
GROUP BY time_scope;`
  },
  {
    name: '按商品 按天下单/支付数',
    sql: `SELECT '下单' as title, time_scope as time_scope, item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(total_fee) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
GROUP BY time_scope,item_id
UNION ALL 
SELECT '支付' as title, time_scope as time_scope, item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(payment) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and pay_time is NOT NULL 
GROUP BY time_scope,item_id;`
  },
  {
    name: '指定商品 按天下单/支付数',
    sql: `SELECT '下单' as title, time_scope as time_scope, '全部' item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(total_fee) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and item_id in ('')
GROUP BY time_scope
UNION ALL 
SELECT '支付' as title, time_scope as time_scope, '全部' item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(payment) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and pay_time is NOT NULL 
and item_id in ('')
GROUP BY time_scope;`
  },
  {
    name: '指定商品 按商品 按天下单/支付数',
    sql: `SELECT '下单' as title, time_scope as time_scope, item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(total_fee) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and item_id in ('')
GROUP BY time_scope,item_id
UNION ALL 
SELECT '支付' as title, time_scope as time_scope, item_id, COUNT(DISTINCT tid) 订单数, COUNT(DISTINCT user_id) 人数,sum(payment) 总金额, sum(num) 商品数
FROM tracking_order_record  
WHERE business_id = '${row.business_id}'
and business_code = '${row.business_code}'
AND time_scope  >= '${row.start_day}'
AND time_scope  <= '${row.end_day}'
and pay_time is NOT NULL 
and item_id in ('')
GROUP BY time_scope,item_id;`
  }
  ];
  executeDialogVisible.value = true;
  return { sql: generatedSql.value, templates: sqlTemplates.value };
};

// 暴露方法给父组件
defineExpose({
  generateSqlFromParams
});

/**
 * 根据参数生成SQL语句
 * @param {Object} params 参数对象
 * @param {string} params.business_id 必传的业务ID
 * @param {string} [params.business_code] 可选的业务编码
 * @param {string} [params.business_value] 可选的业务值
 * @param {string} [params.start_day] 可选的开始日期
 * @param {string} [params.end_day] 可选的结束日期
 * @returns {string} 生成的SQL语句
 */
function generateSqlFromParams(params) {
  if (!params || !params.business_id) {
    throw new Error('business_id is required');
  }

  let sql = `SELECT * FROM tracking_order_record WHERE business_id = '${params.business_id}'`;

  if (params.business_code) {
    sql += ` AND business_code = '${params.business_code}'`;
  }

  if (params.business_value) {
    sql += ` AND business_value = '${params.business_value}'`;
  }

  if (params.start_day) {
    sql += ` AND time_scope >= '${params.start_day}'`;
  }

  if (params.end_day) {
    sql += ` AND time_scope <= '${params.end_day}'`;
  }
  //如果sql不是分号结果 添加分号
  if (!sql.endsWith(';')) {
    sql += ';'
  }
  return sql;
}

/**
 * 根据行数据生成SQL语句
 * @param {Object} row 行数据对象
 * @returns {string} 生成的SQL语句
 */
function generateSqlFromRow(row) {
  return generateSqlFromParams({
    business_id: row.business_id,
    business_code: row.business_code,
    business_value: row.business_value,
    start_day: row.start_day,
    end_day: row.end_day
  });
}
</script>

<style scoped>
.search-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.search-box {
  display: flex;
  width: 600px;
}

.search-input {
  flex: 1;
}

.search-input :deep(.el-input__inner) {
  height: 40px;
  font-size: 16px;
  border-radius: 20px 0 0 20px;
}

.search-btn {
  width: 100px;
  height: 40px;
  border-radius: 0 20px 20px 0;
  font-size: 16px;
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

.title-text,
.sql-text {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #8cb8e3;
}

.title-text:hover,
.sql-text:hover {
  color: #0f7ce8;
}
</style>
